import {Section} from "../models";

export class FetchSections {
  static readonly type = '[Home] FetchSections';

  constructor() {
  }
}



